import { defineStore } from "pinia";
import { computed, reactive } from "vue";

import { destructureFIO } from "@/helpers/destructureFIO";

import type { I_Delivery_Info } from "./delivery.types";

import { useSuccessfulEvaluationStore } from "../successfulEvaluation/successfulEvaluation";

export const useDeliveryStore = defineStore("delivery", () => {
    const successfulEvaluationStore = useSuccessfulEvaluationStore();

    const deliveryInfo = reactive<I_Delivery_Info>({
        fio: "",
        phone: "",
        docNum: "",
        docHouseNum: "",
        docDistrict: "",
        docPostCode: "",
        docStreet: "",
        docCityName: "",
        docApartmentNum: "",
        email: "",
        arrivalDate: "",
        inn: "",
    });

    const destructuredFio = computed(() => destructureFIO(deliveryInfo.fio));

    const isCanNext = computed(() => {
        const NOT_REQUIRED_FIELDS = new Set<keyof I_Delivery_Info>(["docApartmentNum", "inn"]);
        if (!successfulEvaluationStore.isEmailRequired) {
            NOT_REQUIRED_FIELDS.add("email");
        }

        let key: keyof I_Delivery_Info;
        for (key in deliveryInfo) {
            if (Object.prototype.hasOwnProperty.call(deliveryInfo, key)) {
                if (NOT_REQUIRED_FIELDS.has(key)) continue;
                if (deliveryInfo[key]) continue;
                return false;
            }
        }
        return true;
    });

    const restoreToDefault = () => {
        let key: keyof I_Delivery_Info;
        for (key in deliveryInfo) {
            if (Object.prototype.hasOwnProperty.call(deliveryInfo, key)) {
                deliveryInfo[key] = "";
            }
        }
    };

    return {
        deliveryInfo,
        destructuredFio,
        isCanNext,

        restoreToDefault,
    };
});
